import { ReactNode, useState } from 'react'
import AdvancedComboBox, { AdvancedComboBoxProps } from 'components/AdvancedComboBox'
import usePartsSearch from '../../hooks/parts-search'
import FormRow, { FormRowProps } from 'components/FormRow'
import { Part } from 'graphql'

export type PartPickerProps = {
  id?: string,
  debounceKey?: string,
	isDisabled?: boolean,
  label?: ReactNode,
  onChange: ( id: number, option?: Part ) => void,
  selectedPart?: Part,
	required?: boolean,
	formRowProps?: Partial<FormRowProps>,
	hideLabel?: boolean
} & Partial<Omit<AdvancedComboBoxProps<Part>, 'onChange'>>

export default function PartPicker( { debounceKey, selectedPart, onChange, label, formRowProps, hideLabel = false, ...props }: PartPickerProps ): JSX.Element {
	const [ searchString, setSearchString ] = useState( '' )
	const { loading, data } = usePartsSearch( searchString, debounceKey )

	const parts = data?.parts ?? []
	const handleChange = ( part?: Part ) => {
		onChange( part?.id ?? 0, part )
	}
	const fullWidth = props.fullWidth
	const resolvedLabel = hideLabel ? undefined : (label ?? 'Part')

	return (
		<FormRow label={resolvedLabel} {...{ fullWidth, ...formRowProps }}>
			<AdvancedComboBox
				debounceDelayMs={400}
				setSearchString={setSearchString}
				setSelectedOption={handleChange}
				data={parts as Part[]}
				getName={( part: Part ) => `${part.partNumber} - ${part.partClass.description}`}
				getSecondaryText={( part: Part ) => part.provider.name }
				selectedOption={selectedPart}
				isLoading={loading}
				fullWidth={fullWidth}
				{...props}
			/>
		</FormRow>
	)
}
